module.exports = __webpack_public_path__ + "img/banner1.a9304901.jpg";